var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M636.342857 373.028571H387.657143c-36.571429 0-65.828571-29.257143-65.828572-65.828571V109.714286c0-36.571429 29.257143-65.828571 65.828572-65.828572h248.685714c36.571429 0 65.828571 29.257143 65.828572 65.828572v197.485714c0 36.571429-29.257143 65.828571-65.828572 65.828571zM387.657143 102.4c-7.314286 0-7.314286 0-7.314286 7.314286v197.485714c0 7.314286 0 7.314286 7.314286 7.314286h248.685714c7.314286 0 7.314286 0 7.314286-7.314286V109.714286c0-7.314286 0-7.314286-7.314286-7.314286H387.657143z",
    fill: "#d8daea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.228571 921.6H687.542857c-21.942857 0-36.571429-14.628571-36.571428-36.571429V680.228571c0-21.942857 14.628571-36.571429 36.571428-36.571428h248.685714c21.942857 0 36.571429 14.628571 36.571429 36.571428V877.714286c0 21.942857-14.628571 43.885714-36.571429 43.885714z",
    fill: "#d8daea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.228571 950.857143H687.542857c-36.571429 0-65.828571-29.257143-65.828571-65.828572V680.228571c0-36.571429 29.257143-65.828571 65.828571-65.828571h248.685714c36.571429 0 65.828571 29.257143 65.828572 65.828571V877.714286c0 36.571429-29.257143 73.142857-65.828572 73.142857zM687.542857 672.914286c-7.314286 0-7.314286 0-7.314286 7.314285v204.8c0 7.314286 0 7.314286 7.314286 7.314286h248.685714c7.314286 0 7.314286-7.314286 7.314286-14.628571V680.228571c0-7.314286 0-7.314286-7.314286-7.314285H687.542857z",
    fill: "#d8daea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.457143 921.6H87.771429c-21.942857 0-36.571429-14.628571-36.571429-36.571429V687.542857c0-21.942857 14.628571-36.571429 36.571429-36.571428h248.685714c21.942857 0 36.571429 14.628571 36.571428 36.571428v197.485714c0 21.942857-21.942857 36.571429-36.571428 36.571429z",
    fill: "#d8daea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.457143 950.857143H87.771429c-36.571429 0-65.828571-29.257143-65.828572-65.828572V687.542857c0-36.571429 29.257143-65.828571 65.828572-65.828571h248.685714c36.571429 0 65.828571 29.257143 65.828571 65.828571v197.485714c0 36.571429-36.571429 65.828571-65.828571 65.828572zM87.771429 680.228571c-7.314286 0-7.314286 0-7.314286 7.314286v197.485714c0 7.314286 0 7.314286 7.314286 7.314286h248.685714l7.314286-7.314286V687.542857c0-7.314286 0-7.314286-7.314286-7.314286H87.771429zM490.057143 351.085714h43.885714v131.657143h-43.885714zM797.257143 512h36.571428v117.028571h-36.571428z",
    fill: "#d8daea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.171429 504.685714h43.885714v131.657143h-43.885714z",
    fill: "#d8daea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.171429 468.114286h643.657142V512H190.171429z",
    fill: "#d8daea"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartment);
export default __webpack_public_path__ + "static/media/department.c3b6854301d8936774aed30686544622.svg";
export { ForwardRef as ReactComponent };